function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1, 1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 7.5 3 C 6.6774686 3 6 3.6774686 6 4.5 A 0.50005 0.50005 0 1 0 7 4.5 C 7 4.2185314 7.2185314 4 7.5 4 C 7.7814686 4 8 4.2185314 8 4.5 C 8 4.6619916 7.9274638 4.7968012 7.8125 4.8886719 A 0.50005 0.50005 0 0 0 7.8125 4.890625 C 7.375545 5.2414059 7 5.7667242 7 6.4199219 L 7 6.7070312 L 0.47851562 10.158203 A 0.50005 0.50005 0 0 0 0.4140625 10.199219 C 0.05161623 10.470343 -0.058906215 10.946328 0.064453125 11.316406 C 0.18781248 11.686484 0.56111363 12 1.0136719 12 L 13.970703 12 C 14.423261 12 14.794893 11.686368 14.917969 11.316406 C 15.041045 10.946445 14.93215 10.470594 14.570312 10.199219 A 0.50005 0.50005 0 0 0 14.503906 10.158203 L 8 6.7070312 L 8 6.4199219 C 8 6.1491196 8.154455 5.8971441 8.4375 5.6699219 C 8.7805362 5.3957925 9 4.9700084 9 4.5 C 9 3.6774686 8.3225314 3 7.5 3 z M 7.5 7.5761719 L 13.957031 11 L 1.0253906 11 L 7.5 7.5761719 z",
  strokeWidth: 0
}));

var SvgIcons8Hanger = function SvgIcons8Hanger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 18 18",
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcons8Hanger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icons8-hanger.4e921074.svg";
export { ForwardRef as ReactComponent };